export const ACTIVATE_TEST_DRIVE = 'ACTIVATE_TEST_DRIVE';

export const activateTestDrive = () => dispatch => dispatch({ type: ACTIVATE_TEST_DRIVE });
